import {
  authHeader,
  handleResponse,
  handleWithClearErrorResponse,
} from "../_helpers";

const BASE_URL = process.env.REACT_APP_BASE_URL;

// target group By Version
function getTargetGroupsByVersion(queryParams) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };
  const { groupId } = queryParams;
  const endPoint = `/api/admin/v1/groups/version/${groupId}`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function createTargetGroupsByVersion(requestBody) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeader() },
    body: JSON.stringify(requestBody),
  };
  const endPoint = `/api/admin/v1/groups/version`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleWithClearErrorResponse)
    .then((data) => {
      return data;
    });
}

function editTargetGroupsByVersion(requestBody, queryParams) {
  const requestOptions = {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...authHeader() },
    body: JSON.stringify(requestBody),
  };
  const { groupId } = queryParams;
  const endPoint = `/api/admin/v1/groups/version/${groupId}`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleWithClearErrorResponse)
    .then((data) => {
      return data;
    });
}

function addTargetGroupsByVersion(requestBody, queryParams) {
  const requestOptions = {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...authHeader() },
    body: JSON.stringify(requestBody),
  };
  const { groupId } = queryParams;
  const endPoint = `/api/admin/v1/groups/version/${groupId}/targets`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleWithClearErrorResponse)
    .then((data) => {
      return data;
    });
}

function removeTargetGroupsByVersion(queryParams) {
  const requestOptions = {
    method: "DELETE",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };
  const { groupId, target } = queryParams;
  const endPoint = `/api/admin/v1/groups/version/${groupId}/targets/${target}`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleWithClearErrorResponse)
    .then((data) => {
      return data;
    });
}

function deleteTargetGroupsByVersion(queryParams) {
  const requestOptions = {
    method: "DELETE",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };
  const { groupId } = queryParams;
  const endPoint = `/api/admin/v1/groups/version/${groupId}`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleWithClearErrorResponse)
    .then((data) => {
      return data;
    });
}

export const targetGroupsVersionService = {
  getTargetGroupsByVersion,
  createTargetGroupsByVersion,
  editTargetGroupsByVersion,
  addTargetGroupsByVersion,
  removeTargetGroupsByVersion,
  deleteTargetGroupsByVersion,
};
